import { render, staticRenderFns } from "./BlogFeed.vue?vue&type=template&id=0d676aaf&scoped=true"
import script from "./BlogFeed.vue?vue&type=script&lang=ts"
export * from "./BlogFeed.vue?vue&type=script&lang=ts"
import style0 from "./BlogFeed.vue?vue&type=style&index=0&id=0d676aaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d676aaf",
  null
  
)

export default component.exports